// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"2a9c9470","211":"add6c0f2","282":"baede52a","310":"892351d9","333":"454cd526","477":"eb6e47d8","495":"52f33ccf","653":"5057ceb9","675":"a8854886","932":"c2f9d449"}[chunkId] + ".chunk.js";
};